module.exports = __webpack_public_path__ + "img/Mstorybg204.a492b8d5.png";